import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import querystring from 'query-string';

export default function deleteOrderItems(params) {
    const { baseUrl, brandId, country, language, orderItems, uberToken, clientId, clientSecret, langId, additionalHeaders } = params;

    /*
        orderItems should be an array of items to delete, e.g.:
        [
            {
                partNumber: 123456,
                orderItemId: 567,
                quantity: 2
            },
            {
                partNumber: 345678,
                orderItemId: 678,
                quantity: 1
            },
            ...
        ]
    */

    invariant(baseUrl, 'baseUrl is a required param of deleteOrderItems()');
    invariant(brandId, 'brandId is a required param of deleteOrderItems()');
    invariant(country, 'country is a required param of deleteOrderItems()');
    invariant(language, 'language is a required param of deleteOrderItems()');
    invariant(orderItems, 'orderItems is a required param of deleteOrderItems()');
    if (orderItems) {
        invariant(orderItems.length, 'deleteOrderItems(): orderItems param must contain at least one order item');
        orderItems.forEach(function (item, index) {
            invariant(item.partNumber, `deleteOrderItems(): orderItems[${index}] param must contain a partNumber`);
            invariant(item.orderItemId, `deleteOrderItems(): orderItems[${index}] param must contain an orderItemId`);
            invariant(typeof item.quantity === 'number', `deleteOrderItems(): orderItems[${index}] param must contain a quantity value`);
        });
    }
    invariant(uberToken, 'uberToken is a required param of deleteOrderItems()');
    invariant(clientId, 'clientId is a required param of deleteOrderItems()');

    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };
    const query = querystring.stringify({ langId });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart${query ? `?${query}` : ''}`;

    const body = JSON.stringify({
        orderItem: orderItems,
    });

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'DELETE', body }), uberToken, clientId, clientSecret),
        'deleteOrderItems',
    );
}
